// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__container___E0hVN {
    position: fixed;
    bottom: 0;
    right: 2vw;
    width: 400px;
    background-color: #fefefe;
    box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.15);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    overflow: hidden;
}

.style__titleContainer___rmo5x {
    height: 30px;
    display: flex;
    align-items: center;
    background-color: #F8F8FC;
    padding: 10px;
    justify-content: space-between;
}

.style__itemsContainer___ghLoE {
    overflow-y: auto;
}

.style__title___r8dZT {
    font-size: 16px;
}

.style__buttonsContainer___JnAn7 {
    display: flex;
    justify-content: center;
    align-items: center
}

.style__button___r7e1q {
    padding: 5px;
    border-radius: 50%;
}

.style__button___r7e1q:hover {
    background-color: var(--hover-color);
}

/*UploadItem*/

.style__itemContainer___Y4ILu {
    display: flex;
    box-sizing: border-box;
    flex-direction: row;
    align-items: center;
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
    justify-content: space-between;
    overflow-x: hidden;
}

.style__infoContainer____naoO {
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow: hidden;
    flex: 1;
}

.style__img___Uvypu {
    width: 32px;
    height: 32px;
}

.style__fileName___T8avD {
    margin-left: 8px;
    color: var(--grey);
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.style__checkCircle___GNUjA {
    color: var(--success)
}

`, "",{"version":3,"sources":["webpack://./src/components/UploadMenu/style.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,SAAS;IACT,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,2CAA2C;IAC3C,4BAA4B;IAC5B,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;AACxC;;AAEA,aAAa;;AAEb;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,OAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI;AACJ","sourcesContent":[".container {\n    position: fixed;\n    bottom: 0;\n    right: 2vw;\n    width: 400px;\n    background-color: #fefefe;\n    box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.15);\n    border-top-left-radius: 20px;\n    border-top-right-radius: 20px;\n    overflow: hidden;\n}\n\n.titleContainer {\n    height: 30px;\n    display: flex;\n    align-items: center;\n    background-color: #F8F8FC;\n    padding: 10px;\n    justify-content: space-between;\n}\n\n.itemsContainer {\n    overflow-y: auto;\n}\n\n.title {\n    font-size: 16px;\n}\n\n.buttonsContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center\n}\n\n.button {\n    padding: 5px;\n    border-radius: 50%;\n}\n\n.button:hover {\n    background-color: var(--hover-color);\n}\n\n/*UploadItem*/\n\n.itemContainer {\n    display: flex;\n    box-sizing: border-box;\n    flex-direction: row;\n    align-items: center;\n    margin-top: 10px;\n    margin-left: 10px;\n    margin-right: 10px;\n    justify-content: space-between;\n    overflow-x: hidden;\n}\n\n.infoContainer {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    overflow: hidden;\n    flex: 1;\n}\n\n.img {\n    width: 32px;\n    height: 32px;\n}\n\n.fileName {\n    margin-left: 8px;\n    color: var(--grey);\n    flex: 1;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.checkCircle {\n    color: var(--success)\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style__container___E0hVN`,
	"titleContainer": `style__titleContainer___rmo5x`,
	"itemsContainer": `style__itemsContainer___ghLoE`,
	"title": `style__title___r8dZT`,
	"buttonsContainer": `style__buttonsContainer___JnAn7`,
	"button": `style__button___r7e1q`,
	"itemContainer": `style__itemContainer___Y4ILu`,
	"infoContainer": `style__infoContainer____naoO`,
	"img": `style__img___Uvypu`,
	"fileName": `style__fileName___T8avD`,
	"checkCircle": `style__checkCircle___GNUjA`
};
export default ___CSS_LOADER_EXPORT___;
